/**
 * @desc 审批
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(body: defs.business.PaymentOrderApprovalRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/oms/paymentOrder/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
